import { render, staticRenderFns } from "./NationalPatentResponsibleList.vue?vue&type=template&id=2ae1b478&"
import script from "./NationalPatentResponsibleList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentResponsibleList.vue?vue&type=style&index=0&id=2ae1b478&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports